import { makeSearchable } from './arrays.ts';

export const NBATeams = makeSearchable([
  {
    slug: 'charlotte-hornets',
    abbreviation: 'CHA',
    name: 'Hornets',
    fullName: 'Charlotte Hornets',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-cha.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-cha.svg',
    teamStyleGuidePrimaryColor: '#00788C',
  },
  {
    slug: 'atlanta-hawks',
    abbreviation: 'ATL',
    name: 'Hawks',
    fullName: 'Atlanta Hawks',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-atl.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-atl.svg',
    teamStyleGuidePrimaryColor: '#C8102E',
  },
  {
    slug: 'miami-heat',
    abbreviation: 'MIA',
    name: 'Heat',
    fullName: 'Miami Heat',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-mia.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mia.svg',
    teamStyleGuidePrimaryColor: '#98002E',
  },
  {
    slug: 'orlando-magic',
    abbreviation: 'ORL',
    name: 'Magic',
    fullName: 'Orlando Magic',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-orl.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-orl.svg',
    teamStyleGuidePrimaryColor: '#0077C0',
  },
  {
    slug: 'new-york-knicks',
    abbreviation: 'NYK',
    name: 'Knicks',
    fullName: 'New York Knicks',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-nyk.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-nyk.svg',
    teamStyleGuidePrimaryColor: '#F58426',
  },
  {
    slug: 'philadelphia-76ers',
    abbreviation: 'PHI',
    name: '76ers',
    fullName: 'Philadelphia 76ers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-phi.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-phi.svg',
    teamStyleGuidePrimaryColor: '#1D428A',
  },
  {
    slug: 'brooklyn-nets',
    abbreviation: 'BKN',
    name: 'Nets',
    fullName: 'Brooklyn Nets',
    svgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-bkn-24-25.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-bkn-24-25.svg',
    teamStyleGuidePrimaryColor: '#707271',
  },
  {
    slug: 'boston-celtics',
    abbreviation: 'BOS',
    name: 'Celtics',
    fullName: 'Boston Celtics',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-bos.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-bos.svg',
    teamStyleGuidePrimaryColor: '#008348',
  },
  {
    slug: 'toronto-raptors',
    abbreviation: 'TOR',
    name: 'Raptors',
    fullName: 'Toronto Raptors',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-tor.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-tor.svg',
    teamStyleGuidePrimaryColor: '#CE1141',
  },
  {
    slug: 'chicago-bulls',
    abbreviation: 'CHI',
    name: 'Bulls',
    fullName: 'Chicago Bulls',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-chi.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-chi.svg',
    teamStyleGuidePrimaryColor: '#CE1141',
  },
  {
    slug: 'cleveland-cavaliers',
    abbreviation: 'CLE',
    name: 'Cavaliers',
    fullName: 'Cleveland Cavaliers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-cle.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-cle.svg',
    teamStyleGuidePrimaryColor: '#860038',
  },
  {
    slug: 'indiana-pacers',
    abbreviation: 'IND',
    name: 'Pacers',
    fullName: 'Indiana Pacers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-ind.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-ind.svg',
    teamStyleGuidePrimaryColor: '#002D62',
  },
  {
    slug: 'detroit-pistons',
    abbreviation: 'DET',
    name: 'Pistons',
    fullName: 'Detroit Pistons',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-det.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-det.svg',
    teamStyleGuidePrimaryColor: '#1D428A',
  },
  {
    slug: 'milwaukee-bucks',
    abbreviation: 'MIL',
    name: 'Bucks',
    fullName: 'Milwaukee Bucks',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-mil.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mil.svg',
    teamStyleGuidePrimaryColor: '#00471B',
  },
  {
    slug: 'minnesota-timberwolves',
    abbreviation: 'MIN',
    name: 'Timberwolves',
    fullName: 'Minnesota Timberwolves',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-min.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-min.svg',
    teamStyleGuidePrimaryColor: '#266092',
  },
  {
    slug: 'utah-jazz',
    abbreviation: 'UTA',
    name: 'Jazz',
    fullName: 'Utah Jazz',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-uta.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-uta.svg',
    teamStyleGuidePrimaryColor: '#FFF21F',
  },
  {
    slug: 'oklahoma-city-thunder',
    abbreviation: 'OKC',
    name: 'Thunder',
    fullName: 'Oklahoma City Thunder',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-okc.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-okc.svg',
    teamStyleGuidePrimaryColor: '#007AC1',
  },
  {
    slug: 'portland-trail-blazers',
    abbreviation: 'POR',
    name: 'Blazers',
    fullName: 'Portland Trail Blazers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-por.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-por.svg',
    teamStyleGuidePrimaryColor: '#E03A3E',
  },
  {
    slug: 'denver-nuggets',
    abbreviation: 'DEN',
    name: 'Nuggets',
    fullName: 'Denver Nuggets',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-den.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-den.svg',
    teamStyleGuidePrimaryColor: '#0E2240',
  },
  {
    slug: 'memphis-grizzlies',
    abbreviation: 'MEM',
    name: 'Grizzlies',
    fullName: 'Memphis Grizzlies',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-mem.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mem.svg',
    teamStyleGuidePrimaryColor: '#5D76A9',
  },
  {
    slug: 'houston-rockets',
    abbreviation: 'HOU',
    name: 'Rockets',
    fullName: 'Houston Rockets',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-hou.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-hou.svg',
    teamStyleGuidePrimaryColor: '#CE1141',
  },
  {
    slug: 'new-orleans-pelicans',
    abbreviation: 'NOP',
    name: 'Pelicans',
    fullName: 'New Orleans Pelicans',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-nop.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-nop.svg',
    teamStyleGuidePrimaryColor: '#0A2240',
  },
  {
    slug: 'san-antonio-spurs',
    abbreviation: 'SAS',
    name: 'Spurs',
    fullName: 'San Antonio Spurs',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-sas.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-sas.svg',
    teamStyleGuidePrimaryColor: '#C4CED4',
  },
  {
    slug: 'washington-wizards',
    abbreviation: 'WAS',
    name: 'Wizards',
    fullName: 'Washington Wizards',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-was.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-was.svg',
    teamStyleGuidePrimaryColor: '#002B5C',
  },
  {
    slug: 'los-angeles-lakers',
    abbreviation: 'LAL',
    name: 'Lakers',
    fullName: 'Los Angeles Lakers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-lal.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-lal.svg',
    teamStyleGuidePrimaryColor: '#FDB927',
  },
  {
    slug: 'la-clippers',
    abbreviation: 'LAC',
    name: 'Clippers',
    fullName: 'LA Clippers',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-lac.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-lac.svg',
    teamStyleGuidePrimaryColor: '#1D428A',
  },
  {
    slug: 'phoenix-suns',
    abbreviation: 'PHX',
    name: 'Suns',
    fullName: 'Phoenix Suns',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-phx.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-phx.svg',
    teamStyleGuidePrimaryColor: '#1D1160',
  },
  {
    slug: 'sacramento-kings',
    abbreviation: 'SAC',
    name: 'Kings',
    fullName: 'Sacramento Kings',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-sac.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-sac.svg',
    teamStyleGuidePrimaryColor: '#5A2D81',
  },
  {
    slug: 'dallas-mavericks',
    abbreviation: 'DAL',
    name: 'Mavericks',
    fullName: 'Dallas Mavericks',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-dal.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-dal.svg',
    teamStyleGuidePrimaryColor: '#0064B1',
  },
  {
    slug: 'golden-state-warriors',
    abbreviation: 'GSW',
    name: 'Warriors',
    fullName: 'Golden State Warriors',
    svgUrl: 'https://frontend-assets.sorare.com/nba/logos/logo-team-gsw.svg',
    monochromeSvgUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-gsw.svg',
    teamStyleGuidePrimaryColor: '#FDB927',
  },
] as const);

export const NBAClubs = makeSearchable([
  {
    slug: 'charlotte-hornets',
    shortName: 'CHA',
    name: 'Charlotte Hornets',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-cha.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-cha.svg',
    styleGuideColor: '#00788C',
  },
  {
    slug: 'atlanta-hawks',
    shortName: 'ATL',
    name: 'Atlanta Hawks',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-atl.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-atl.svg',
    styleGuideColor: '#C8102E',
  },
  {
    slug: 'miami-heat',
    shortName: 'MIA',
    name: 'Miami Heat',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-mia.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mia.svg',
    styleGuideColor: '#98002E',
  },
  {
    slug: 'orlando-magic',
    shortName: 'ORL',
    name: 'Orlando Magic',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-orl.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-orl.svg',
    styleGuideColor: '#0077C0',
  },
  {
    slug: 'new-york-knicks',
    shortName: 'NYK',
    name: 'New York Knicks',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-nyk.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-nyk.svg',
    styleGuideColor: '#F58426',
  },
  {
    slug: 'philadelphia-76ers',
    shortName: 'PHI',
    name: 'Philadelphia 76ers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-phi.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-phi.svg',
    styleGuideColor: '#1D428A',
  },
  {
    slug: 'brooklyn-nets',
    shortName: 'BKN',
    name: 'Brooklyn Nets',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-bkn-24-25.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-bkn-24-25.svg',
    styleGuideColor: '#707271',
  },
  {
    slug: 'boston-celtics',
    shortName: 'BOS',
    name: 'Boston Celtics',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-bos.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-bos.svg',
    styleGuideColor: '#008348',
  },
  {
    slug: 'toronto-raptors',
    shortName: 'TOR',
    name: 'Toronto Raptors',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-tor.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-tor.svg',
    styleGuideColor: '#CE1141',
  },
  {
    slug: 'chicago-bulls',
    shortName: 'CHI',
    name: 'Chicago Bulls',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-chi.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-chi.svg',
    styleGuideColor: '#CE1141',
  },
  {
    slug: 'cleveland-cavaliers',
    shortName: 'CLE',
    name: 'Cleveland Cavaliers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-cle.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-cle.svg',
    styleGuideColor: '#860038',
  },
  {
    slug: 'indiana-pacers',
    shortName: 'IND',
    name: 'Indiana Pacers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-ind.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-ind.svg',
    styleGuideColor: '#002D62',
  },
  {
    slug: 'detroit-pistons',
    shortName: 'DET',
    name: 'Detroit Pistons',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-det.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-det.svg',
    styleGuideColor: '#1D428A',
  },
  {
    slug: 'milwaukee-bucks',
    shortName: 'MIL',
    name: 'Milwaukee Bucks',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-mil.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mil.svg',
    styleGuideColor: '#00471B',
  },
  {
    slug: 'minnesota-timberwolves',
    shortName: 'MIN',
    name: 'Minnesota Timberwolves',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-min.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-min.svg',
    styleGuideColor: '#266092',
  },
  {
    slug: 'utah-jazz',
    shortName: 'UTA',
    name: 'Utah Jazz',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-uta.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-uta.svg',
    styleGuideColor: '#FFF21F',
  },
  {
    slug: 'oklahoma-city-thunder',
    shortName: 'OKC',
    name: 'Oklahoma City Thunder',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-okc.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-okc.svg',
    styleGuideColor: '#007AC1',
  },
  {
    slug: 'portland-trail-blazers',
    shortName: 'POR',
    name: 'Portland Trail Blazers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-por.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-por.svg',
    styleGuideColor: '#E03A3E',
  },
  {
    slug: 'denver-nuggets',
    shortName: 'DEN',
    name: 'Denver Nuggets',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-den.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-den.svg',
    styleGuideColor: '#0E2240',
  },
  {
    slug: 'memphis-grizzlies',
    shortName: 'MEM',
    name: 'Memphis Grizzlies',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-mem.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-mem.svg',
    styleGuideColor: '#5D76A9',
  },
  {
    slug: 'houston-rockets',
    shortName: 'HOU',
    name: 'Houston Rockets',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-hou.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-hou.svg',
    styleGuideColor: '#CE1141',
  },
  {
    slug: 'new-orleans-pelicans',
    shortName: 'NOP',
    name: 'New Orleans Pelicans',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-nop.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-nop.svg',
    styleGuideColor: '#0A2240',
  },
  {
    slug: 'san-antonio-spurs',
    shortName: 'SAS',
    name: 'San Antonio Spurs',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-sas.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-sas.svg',
    styleGuideColor: '#C4CED4',
  },
  {
    slug: 'washington-wizards',
    shortName: 'WAS',
    name: 'Washington Wizards',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-was.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-was.svg',
    styleGuideColor: '#002B5C',
  },
  {
    slug: 'los-angeles-lakers',
    shortName: 'LAL',
    name: 'Los Angeles Lakers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-lal.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-lal.svg',
    styleGuideColor: '#FDB927',
  },
  {
    slug: 'la-clippers',
    shortName: 'LAC',
    name: 'LA Clippers',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-lac-24-25.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-lac-24-25.svg',
    styleGuideColor: '#1D428A',
  },
  {
    slug: 'phoenix-suns',
    shortName: 'PHX',
    name: 'Phoenix Suns',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-phx.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-phx.svg',
    styleGuideColor: '#1D1160',
  },
  {
    slug: 'sacramento-kings',
    shortName: 'SAC',
    name: 'Sacramento Kings',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-sac.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-sac.svg',
    styleGuideColor: '#5A2D81',
  },
  {
    slug: 'dallas-mavericks',
    shortName: 'DAL',
    name: 'Dallas Mavericks',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-dal.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-dal.svg',
    styleGuideColor: '#0064B1',
  },
  {
    slug: 'golden-state-warriors',
    shortName: 'GSW',
    name: 'Golden State Warriors',
    pictureUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-team-gsw.svg',
    pictureSecondaryUrl:
      'https://frontend-assets.sorare.com/nba/logos/logo-monochrome-team-gsw.svg',
    styleGuideColor: '#FDB927',
  },
] as const);
